export default "__VITE_ASSET__ca5dfb7b__"